import HeroCarousel from "@/components/feature/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import LatestSection from "./components/LatestSection";
import HotSection from "./components/HotSection";
import SiteIntro from "./components/SiteIntro";
import { getFeatured } from "@/lib/media";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Home() {
  const featured = getFeatured(5);

  useDocumentMeta(
    "免费播放片大片 - 热门电影电视剧在线尽享",
    "免费播放片大片网站汇聚最新最全的电影、电视剧资源，满足用户在线观看大片的需求，涵盖多种类型，提供便捷的影视内容浏览体验。",
    "免费播放片大片,电影观看,电视剧资源,在线大片,影视在线观看,高清电影,热门影片",
  );

  return (
    <div className="bg-background-950">
      <h1 className="sr-only">免费播放片大片 - 热门电影电视剧在线尽享</h1>
      <HeroCarousel items={featured} />
      <CategoryEntry />
      <LatestSection />
      <HotSection />
      <SiteIntro />
    </div>
  );
}